import { render, staticRenderFns } from "./disputes-table-breaks.vue?vue&type=template&id=290501a4"
import script from "./disputes-table-breaks.vue?vue&type=script&lang=js"
export * from "./disputes-table-breaks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports